import React, { useState } from 'react';
import { StepHelpKey } from '../data/stepHelpContent';
import StepHelpPanel from './StepHelpPanel';
import stepStyles from '../styles/stepCommon.module.css';
import styles from '../styles/stepHelpPanel.module.css';

interface StepHelpButtonProps {
  stepKey: StepHelpKey;
  variant?: 'icon' | 'link';
  linkLabel?: string;
  className?: string;
}

const StepHelpButton: React.FC<StepHelpButtonProps> = ({
  stepKey,
  variant = 'icon',
  linkLabel = 'How step work in Recovery Commons works',
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {variant === 'icon' ? (
        <button
          type="button"
          className={`${stepStyles.helpBtn} ${className || ''}`}
          onClick={() => setIsOpen(true)}
          title="Help"
          aria-label="Help"
        >
          ?
        </button>
      ) : (
        <button
          type="button"
          className={`${styles.helpLinkButton} ${className || ''}`}
          onClick={() => setIsOpen(true)}
        >
          {linkLabel}
        </button>
      )}
      <StepHelpPanel isOpen={isOpen} onClose={() => setIsOpen(false)} stepKey={stepKey} />
    </>
  );
};

export default StepHelpButton;
